<template>
  <div class="rodape-usuario-container">
    <div class="rodape-usuario-spacer" aria-hidden="true"></div>
    <footer class="rodape-usuario">
      <div class="rodape-usuario__conteudo">
        <span class="rodape-usuario__item rodape-usuario__nome" :title="usuario">
          <b-icon class="rodape-usuario__icone" icon="person-fill" aria-hidden="true"></b-icon>
          <span class="rodape-usuario__texto">{{ usuario.toLowerCase() }}</span>
        </span>
        <span class="rodape-usuario__item rodape-usuario__perfil" :title="perfil">
          <b-icon class="rodape-usuario__icone" icon="person-badge-fill" aria-hidden="true"></b-icon>
          <span class="rodape-usuario__texto">{{ perfil.toLowerCase() }}</span>
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
import {PerfilService} from '@/services/PerfilService';

export default {
  name: 'RodapeUsuario',
  data() {
    return {
      perfilService: new PerfilService()
    };
  },
  computed: {
    usuario() {
      return this.perfilService.usuario || 'Usuário';
    },
    perfil() {
      return this.perfilService.obterTipoPerfil || 'Perfil não informado';
    }
  }
};
</script>

<style scoped>
.rodape-usuario-spacer {
  height: 40px;
}

.rodape-usuario {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  padding: 8px 20px;
  color: #ffffff;
  background: linear-gradient(135deg, #303f9f 0%, #1e2a78 100%);
  box-shadow: 0 -4px 15px rgba(48, 63, 159, 0.25);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.rodape-usuario:hover {
  box-shadow: 0 -6px 20px rgba(48, 63, 159, 0.35);
}

.rodape-usuario__conteudo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  max-width: 1400px;
}

.rodape-usuario__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  transition: all 0.2s ease;
  cursor: default;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.rodape-usuario__item:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.rodape-usuario__icone {
  font-size: 1rem;
  filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
}

.rodape-usuario__texto {
  font-weight: 500;
  font-size: 0.85rem;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.rodape-usuario__nome {
  text-transform: capitalize;
}

.rodape-usuario__perfil {
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}

@media (max-width: 480px) {
  .rodape-usuario {
    padding: 10px 16px;
  }
  .rodape-usuario__item {
    padding: 4px 10px;
  }
  .rodape-usuario__texto {
    font-size: 0.8rem;
  }
}
</style>
